/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 13/11/2023
 */


export const ClearanceLevelEnum = Object.freeze({
	// make sure to update firestore.rules maxClearanceLevel() return value
	// whenever a new higher level is added
	ALL: 		200,
	PHI: 		200,
	STANDARD: 	100,
})

// export const GrantedAccessFullObj = {label: "Full (PHI + Standard resources)", value: AccessLevelEnum.ALL, tooltip: "Full access to all client's files, including those marked as PHI in your library (Private Health Information)"}
export const GrantedAccessFullObj = {label: "Full (PHI + Standard resources)", labelShort: "PHI", value: ClearanceLevelEnum.PHI, tooltip: "If a client file shared with this team member, they will be able to see it even if it's marked as PHI in your library (Private Health Information)"}
export const GrantedAccessPHIObj = {label: "PHI + Standard resources", labelShort: "PHI", value: ClearanceLevelEnum.PHI, tooltip: GrantedAccessFullObj.tooltip}
export const GrantedAccessStandardObj = {label: "Standard resources only", labelShort: "Standard", value: ClearanceLevelEnum.STANDARD, tooltip: "Access to client's standard resources only. <br/><br/>Client's files marked as PHI in your library (Private Health Information) will not show up for this person, unless explicitly shared with them."}

export const RequiredAccessPHIObj = {label: "PHI", value: ClearanceLevelEnum.PHI, tooltip: "Client's files marked as PHI will only be visible to those with at least PHI access level (Private Health Information)"}
export const RequiredAccessStandardObj = {label: "Standard resources", value: ClearanceLevelEnum.STANDARD, tooltip: GrantedAccessStandardObj.tooltip}

export const GrantedAccessLevelArray = [
	GrantedAccessFullObj,
	GrantedAccessStandardObj,
]
export const RequiredAccessLevelArray = [
	RequiredAccessPHIObj,
	RequiredAccessStandardObj,
]
export const AccessLevelObjectAllArray = [
	GrantedAccessFullObj,
	RequiredAccessPHIObj,
	RequiredAccessStandardObj,
]

export const getGrantedAccessLevelObject = (accessLevel) => {
	switch (accessLevel) {
		case ClearanceLevelEnum.ALL:
			return GrantedAccessFullObj
		case ClearanceLevelEnum.PHI:
			return GrantedAccessPHIObj
		case ClearanceLevelEnum.STANDARD:
			return GrantedAccessStandardObj
		default:
			return null
	}
}

export const getRequiredAccessLevelObject = (accessLevel) => {
	switch (accessLevel) {
		case ClearanceLevelEnum.ALL:
			return RequiredAccessPHIObj
		case ClearanceLevelEnum.PHI:
			return RequiredAccessPHIObj
		case ClearanceLevelEnum.STANDARD:
			return RequiredAccessStandardObj
		default:
			return null
	}
}

export const AccessLevelArrayAll = [
	ClearanceLevelEnum.STANDARD,
	ClearanceLevelEnum.PHI,
]


export const getGrantedClearanceLevelArray = (clearanceLevel) => {
	return AccessLevelArrayAll.filter((level) => level <= clearanceLevel)
}
